module.exports = __webpack_public_path__ + "static/img/textbook.65169bf9.png";